import { NgModule } from '@angular/core';
import { AddNewsletterComponent } from './add-newsletter/add-newsletter.component';
import { EditNewsletterComponent } from './edit-newsletter/edit-newsletter.component';
import { NewsletterListComponent } from './newsletter-list/newsletter-list.component';
import { NewsletterManagementRoutingModule } from './newsletter-management-routing.module';

@NgModule({
  imports: [
    NewsletterListComponent,
    EditNewsletterComponent,
    AddNewsletterComponent,
    NewsletterManagementRoutingModule,
  ],
})
export class NewsletterManagementModule {}
